import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { MapLayerKey, MapLayerSelectionService } from '../../../../services/map-layer-selection.service';
import { CatchHeatService } from '../../../../services/catch-heat.service';
import { FIELD_TILES, HEAT_TILE, MapLayerTile, PIN_TILES } from '../../../../shared/utils/map-layer-tiles';

/**
 * The on-map layer switcher: a vertical strip of every layer (heatmap for fleet members, the six
 * ocean fields, then the marker layers) with the live one ringed — Flutter's `MapLayerRail`.
 * Same single-selection model as the picker: a tap swaps the live layer immediately, and the red ✕
 * at the foot clears everything. Unlike the old combo-card strip it stays up for marker layers and
 * heat, which have no player card of their own.
 */
@Component({
  selector: 'app-map-layer-switcher',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './map-layer-switcher.component.html',
  styleUrl: './map-layer-switcher.component.scss',
})
export class MapLayerSwitcherComponent implements OnInit, OnDestroy {
  selected: MapLayerKey | null = null;
  isHeatMember = false;

  readonly fields = FIELD_TILES;
  readonly pins = PIN_TILES;
  readonly heat = HEAT_TILE;

  private subs: Subscription[] = [];

  constructor(
    private selection: MapLayerSelectionService,
    private catchHeat: CatchHeatService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.catchHeat.ensureMembership();
    this.subs.push(
      this.selection.selected$.subscribe((key) => { this.selected = key; this.cdr.markForCheck(); }),
      this.catchHeat.isMember$.subscribe((m) => { this.isHeatMember = m; this.cdr.markForCheck(); }),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  pick(tile: MapLayerTile): void {
    if (this.selected !== tile.key) this.selection.select(tile.key);
  }

  clear(): void {
    this.selection.clear();
  }
}
